import { render, staticRenderFns } from "./OfficeBacklog.vue?vue&type=template&id=49ce6cd8&"
import script from "./OfficeBacklog.vue?vue&type=script&lang=js&"
export * from "./OfficeBacklog.vue?vue&type=script&lang=js&"
import style0 from "./OfficeBacklog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports